export const LEARNING_LEVEL_LABEL_MAP = {
  AWARENESS: "Basic",
  EXPLANATORY: "Intermediate",
  PRACTITIONER: "Advanced",
  Awareness: "Basic",
  Explanatory: "Intermediate",
  Practitioner: "Advanced",
  awareness: "Basic",
  explanatory: "Intermediate",
  practitioner: "Advanced",
  BASIC: "Basic",
  INTERMEDIATE: "Intermediate",
  ADVANCED: "Advanced",
  Basic: "Basic",
  Intermediate: "Intermediate",
  Advanced: "Advanced",
  basic: "Basic",
  intermediate: "Intermediate",
  advanced: "Advanced",
  "1": "Basic",
  "2": "Intermediate",
  "3": "Advanced",
  1: "Basic",
  2: "Intermediate",
  3: "Advanced",
};

export const LEARNING_LEVELS_RENAME_MAP = {
  AWARENESS: "BASIC",
  EXPLANATORY: "INTERMEDIATE",
  PRACTITIONER: "ADVANCED",
};

export const LEARNING_LEVELS = [
  "awareness",
  "explanatory",
  "practitioner",
];

export const LEARNING_STATUSES = [
  "Not Started",
  "In Progress",
  "Unrealized Potential",
  "graduated",
  "pro",
];

export const getLearningLevelLabel = (level) => {
  if (!level || level === "N/A" || level === "NA") return "Basic";
  const trimmed = typeof level === "string" ? level.trim() : String(level);
  return (
    LEARNING_LEVEL_LABEL_MAP[trimmed] ||
    LEARNING_LEVEL_LABEL_MAP[trimmed.toUpperCase()] ||
    LEARNING_LEVEL_LABEL_MAP[trimmed.toLowerCase()] ||
    "Basic"
  );
};
